import { isServer } from './isServer';

const DEFAULT_ID = '2';

export function getTestScope(variants = 2, df = DEFAULT_ID) {
  if (!isServer) {
    try {
      const randomId = parseInt(
        localStorage.getItem('randomId') ?? df
      ) as number;
      return randomId % variants;
    } catch (e) {
      // console.log(e)
    }
  }
  return 0;
}

export function landingAbTest(): number {
  const testScope = getTestScope(3, DEFAULT_ID);
  if (!isServer) {
    window['dataLayer']?.push({
      event: 'home_ab_test',
      experimentNameC3: 'landingAbTest',
      experimentIDC3: testScope == 2 ? 'redirectToSearchPage' : testScope == 1 ? 'changePositionSearchContent' : 'control',
    });
  }
  return testScope;
}

const PARKING_DEFAULT_ID = '0';

export function cardsAbTest(): number {
  const testScope = getTestScope(4, PARKING_DEFAULT_ID);
  if (!isServer) {
    window['dataLayer']?.push({
      event: 'confirmed_ab_test',
      experimentName: 'cardsabcdTest',
      experimentID: testScope == 3 ? 'EXCard' : testScope == 2 ? 'SHCard' : testScope == 1 ? 'APRCard' : 'control',
    });
  }
  return testScope;
}

const PARKINGAT_DEFAULT_ID = '2';
const PARKINGAT_AB_LOCALES = ['PHL', 'CLE', 'IND', 'PDX', 'IAH'];

export function applyParkingProtectionAB(facility: any, setTestScope) {
  const code = facility?.facility_url_code?.toUpperCase();

  if (code && PARKINGAT_AB_LOCALES.some((locale) => code.startsWith(locale))) {
    setTestScope(parkingProtectionAbTest());
  }
}

export function parkingProtectionAbTest(): number {
  const testScope = getTestScope(2, PARKINGAT_DEFAULT_ID);
  if (!isServer) {
    window['dataLayer']?.push({
      event: 'parkingat_ab_test',
      experimentNameC2: 'parkingProtection',
      experimentIDC2: testScope ? 'variant1' : 'control',
    });
  }
  return testScope;
}
